import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "@/lib/analytics";

/**
 * Mounts inside the Router. Fires a GA4 page_view on every route change,
 * including the first paint after the user grants analytics consent.
 * No-op until consent + GA4 are live.
 */
export const AnalyticsRouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Defer to next tick so the new page's <SEO> has updated document.title.
    const id = window.setTimeout(() => {
      trackPageview(location.pathname + location.search, document.title);
    }, 0);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);

  return null;
};
